<script setup lang="ts">
const props = defineProps<{ handle: string }>()
const account = await fetchAccountByHandle(props.handle)
</script>
<template>
  <AccountHover v-if="account" :account="account">
    <slot />
  </AccountHover>
</template>
